/* ═══════════════════════════════════════════════════════
   NDK Video Hub Modal — JavaScript
   ═══════════════════════════════════════════════════════
   Performance:
     - 0 iframes on page load
     - Iframe created on open / video switch
     - Max 1 iframe at any time
     - Iframe destroyed on close (audio cut + memory free)
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function init() {
    // ── Refs ──
    var modal = document.getElementById('ndk-video-modal');
    if (!modal) return;

    // ═══ CRITICAL: Move modal to <body> root to escape
    // any parent stacking context (Impulse theme wraps
    // product-images in positioned containers with z-index) ═══
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var player = document.getElementById('ndk-vm-player');
    var playlistList = document.getElementById('ndk-vm-playlist-list');
    var videos = window.ndkVideos || [];
    if (!videos.length) return;

    var currentIndex = 0;
    var isOpen = false;
    var savedScrollY = 0;

    // ── Play icon SVG ──
    var playSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="white"/><polygon points="8,6 15,10 8,14" fill="#111"/></svg>';

    // ── Build playlist ──
    function buildPlaylist() {
      if (!playlistList) return;
      var html = '';
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        html += '<div class="ndk-vm__item' + (i === 0 ? ' ndk-vm__item--active' : '') + '" data-ndk-video-index="' + i + '">';
        html += '  <div class="ndk-vm__item-left">';
        html += '    <img class="ndk-vm__item-thumb" src="' + v.thumb + '" alt="' + v.title.replace(/"/g, '&quot;') + '" loading="lazy" />';
        html += '    <span class="ndk-vm__item-title">' + v.title + '</span>';
        html += '  </div>';
        html += '  <div class="ndk-vm__item-play">' + playSvg + '</div>';
        html += '</div>';
      }
      playlistList.innerHTML = html;
    }

    // ── Iframe lifecycle ──
    function createIframe(index) {
      destroyIframe();
      var v = videos[index];
      if (!v) return;

      var iframe = document.createElement('iframe');
      iframe.src = v.url + '?autoplay=true&preload=false';
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('allow', 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'true');
      player.appendChild(iframe);

      currentIndex = index;
      updateActiveItem(index);
    }

    function destroyIframe() {
      var existing = player.querySelector('iframe');
      if (existing) {
        existing.src = 'about:blank';
        existing.remove();
      }
    }

    // ── Active state ──
    function updateActiveItem(index) {
      var items = playlistList.querySelectorAll('.ndk-vm__item');
      for (var i = 0; i < items.length; i++) {
        if (i === index) {
          items[i].classList.add('ndk-vm__item--active');
        } else {
          items[i].classList.remove('ndk-vm__item--active');
        }
      }
    }

    // ── Open modal ──
    function openModal(startIndex) {
      if (isOpen) return;
      isOpen = true;

      savedScrollY = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';

      if (!playlistList.children.length) {
        buildPlaylist();
      }

      modal.setAttribute('aria-hidden', 'false');
      createIframe(startIndex || 0);
      history.pushState({ ndkVideoModal: true }, '');
    }

    // ── Close modal ──
    function closeModal() {
      if (!isOpen) return;
      isOpen = false;

      destroyIframe();
      modal.setAttribute('aria-hidden', 'true');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
    }

    // ══════════════════════════════════════════════════
    // EVENT LISTENERS
    // ══════════════════════════════════════════════════

    // ── Open trigger: click (capture phase) ──
    // Capture phase fires BEFORE Slick can stopPropagation
    document.addEventListener('click', function (e) {
      if (isOpen) return;
      var trigger = e.target.closest('[data-ndk-open-video-modal]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openModal(0);
        return false;
      }
    }, true);

    // ── Open trigger: touchend for mobile ──
    // Slick slider cancels click events on mobile via swipe detection.
    // We track touchstart position and compare with touchend:
    // if finger moved < 20px → it's a tap → open modal.
    var touchStartData = null;

    document.addEventListener('touchstart', function (e) {
      var trigger = e.target.closest('[data-ndk-open-video-modal]');
      if (!trigger) { touchStartData = null; return; }
      var touch = e.touches[0];
      touchStartData = {
        x: touch.clientX,
        y: touch.clientY,
        time: Date.now()
      };
    }, { capture: true, passive: true });

    document.addEventListener('touchend', function (e) {
      if (!touchStartData) return;
      var trigger = e.target.closest('[data-ndk-open-video-modal]');
      if (!trigger) { touchStartData = null; return; }

      var touch = e.changedTouches[0];
      var dx = Math.abs(touch.clientX - touchStartData.x);
      var dy = Math.abs(touch.clientY - touchStartData.y);
      var dt = Date.now() - touchStartData.time;
      touchStartData = null;

      // Tap = moved less than 20px and lasted less than 500ms
      if (dx < 20 && dy < 20 && dt < 500) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // Small delay to let Slick finish its touch handling
        setTimeout(function () { openModal(0); }, 50);
      }
    }, true);

    // ── Close triggers ──
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ndk-close-video-modal]')) {
        closeModal();
        if (history.state && history.state.ndkVideoModal) {
          history.back();
        }
      }
    });

    // ── Playlist click → switch video ──
    modal.addEventListener('click', function (e) {
      var item = e.target.closest('[data-ndk-video-index]');
      if (!item) return;
      var idx = parseInt(item.getAttribute('data-ndk-video-index'), 10);
      if (idx === currentIndex) return;
      createIframe(idx);
    });

    // ── Escape key ──
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeModal();
        if (history.state && history.state.ndkVideoModal) {
          history.back();
        }
      }
    });

    // ── Back button → close modal instead of navigating away ──
    window.addEventListener('popstate', function () {
      if (isOpen) {
        closeModal();
      }
    });

    // ── Expose globally ──
    window.ndkOpenVideoModal = openModal;
    window.ndkCloseVideoModal = closeModal;
  }

  // ── Init when DOM ready ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
